<template>
  <v-app>
    <home-app-bar />

    <home-view />

    <DialogContainer />
    <!-- <home-footer /> -->
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "AdminLayout",

  components: {
    HomeAppBar: () => import("./AppBar"),
    HomeView: () => import("./View"),
    DialogContainer: () =>
      import("@/components/admin/dialogs/DialogsContainer.vue")
  },

  methods: {
    ...mapActions("admin", ["fetchAdminPerfil"])
  },

  async mounted() {
    await this.fetchAdminPerfil();
  }
};
</script>

<style lang="sass">
html
  overflow-y: auto
</style>

